import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../../lib/cn';

const badgeVariants = cva('badge', {
  variants: {
    variant: {
      success: 'badge-success',
      warning: 'badge-warning',
      danger: 'badge-danger',
      info: 'badge-info',
      neutral: 'badge-neutral',
      accent: 'badge-accent',
      default: 'badge-neutral',
      destructive: 'badge-danger',
      secondary: 'badge-neutral',
      outline: 'badge-neutral',
    },
  },
  defaultVariants: {
    variant: 'neutral',
  },
});

type BadgeVariantProps = VariantProps<typeof badgeVariants>;

interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>, BadgeVariantProps {}

const Badge = React.forwardRef<HTMLSpanElement, BadgeProps>(function Badge(
  { className, variant, ...props },
  ref,
) {
  return (
    <span
      ref={ref}
      className={cn(badgeVariants({ variant }), className)}
      {...props}
    />
  );
});

export { Badge, badgeVariants };
export type { BadgeProps };
